import React from 'react';
import { Markets as MarketsStrip, Stats, CallToAction } from '../components/Sections.jsx';

function MarketsPage() {
  return (
    <main>
      <MarketsStrip />
      <Stats />
      <CallToAction />
    </main>
  );
}

export default MarketsPage;






